
export default (val, type) => {
  let newVal = val;

  newVal = String(newVal).replace(/CURRENT_YEAR/g, (new Date()).getFullYear());

  if (type === 'number') {
    newVal = parseFloat(newVal);
  }

  return newVal;
};



// WEBPACK FOOTER //
// ./src/filter/limit-replacers.js